import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { IOfferEventDetailFragment } from 'graphql/types';
import { SubscriptionTable } from 'offer/tables/SubscriptionsTable';
import { useOfferEventEnrollmentList } from 'offer/hooks/useOfferEventEnrollmentList';

interface IProps {
    disableClickRows?: boolean;
    offerEvent: IOfferEventDetailFragment;
}

export const OfferEventEnrollmentList = ({
    disableClickRows,
    offerEvent,
}: IProps) => {
    const [translate] = useTranslation();

    const {
        enrollments,
        loading,
        handleSearch,
        handleFilterSelect,
        searchQueryParam,
        selectionProps,
        filters,
        filtersLoading,
        selectedFilters,
        paginationSettings,
        setPage,
    } = useOfferEventEnrollmentList(offerEvent.id);

    return (
        <>
            <Typography fontWeight={700} sx={{ mb: 3 }}>
                {translate('subscriptions')}
            </Typography>

            <SubscriptionTable
                disableClickRows={disableClickRows}
                loading={loading}
                offerEvent={offerEvent}
                paginationProps={{ paginationSettings, setPage }}
                searchProps={{
                    handleSearch: handleSearch,
                    handleFilterSelect: handleFilterSelect,
                    searchQueryParam,
                    filters,
                    filtersLoading,
                    selectedFilters,
                }}
                selectionProps={selectionProps}
                subscriptions={enrollments}
            />
        </>
    );
};
